// import api's and mutations
import { saveRosterStateSettings } from 'RestAPIs/roster/state-settings';

// import components
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

// import hooks
import { useMutation, useQueryClient } from 'react-query';

// import types
import type { RosterStateSettingsValues } from 'components/shared/PlanningCycle/PlanningCycle.types';

// import utils
import { t } from 'i18next';
import type { AxiosError } from 'axios';

const useSaveRosterStateSettings = () => {
  const queryClient = useQueryClient();

  return useMutation<unknown, AxiosError<unknown>, RosterStateSettingsValues>(
    ({ costCenterId, planningCyclePayload }) =>
      saveRosterStateSettings({ costCenterId, planningCyclePayload }),
    {
      onSuccess: (costCenterId, planningCyclePayload) => {
        queryClient.invalidateQueries([
          'rosterStateSettings',
          costCenterId,
          planningCyclePayload
        ]);
        showSuccessSnackbar();
      },
      onError: (error: AxiosError<any>) => {
        if (
          error?.response?.data?.error?.message ===
          'user_with_no_approve_hours_grant'
        ) {
          showErrorSnackbar(
            t('costCenterSettings.error.userWithNoApproveHoursGrant')
          );
        } else {
          showErrorSnackbar();
        }
      }
    }
  );
};

export default useSaveRosterStateSettings;
